import './index.scss'

$('.section1 ul li .common-btn').on('click',function(){

  if($(this).hasClass('active')){
    $(this).removeClass('active').closest('li').removeClass('active')
  }else{
    $(this).addClass('active').closest('li').addClass('active')
  }
})